import RenderSuggestion, {RenderSuggestionProps, TitleLink} from "./RenderSuggestion";

export default RenderSuggestion;
export {TitleLink}
export type {RenderSuggestionProps};
